export const membershipsData = [
  {
    service: "Meraki Method",
    rate: "$280/Month",
    details:
      "Experience effortless elegance with two signature 4-blow-dry services each month, designed to keep you feeling polished and refreshed. Enjoy 10% off our curated selection of premium retail products, complimentary bubbles to sip during your service, and a relaxing scalp massage to melt away the day. Because beauty is a ritual, and you deserve the finest.",
  },
  {
    service: "Meraki Method (Extensions)",
    rate: "$340/Month",
    details:
      "Experience effortless elegance with two signature 4-blow-dry services each month, designed to keep you feeling polished and refreshed. Enjoy 10% off our curated selection of premium retail products, complimentary bubbles to sip during your service, and a relaxing scalp massage to melt away the day. A method to your beautiful madness.",
  },
  {
    service: "The Muse",
    rate: "$150/Month",
    details:
      "A nod to the modern muse effortlessly radiant, intentionally refined. Includes 2 blow-dry services each month, perfect for those who crave softness, shine, and self-care without the full schedule. Sip on complimentary bubbles, unwind with a luxurious scalp massage, and enjoy 10% off our curated premium retail, all in a space designed to inspire.",
  },
  {
    service: "The Muse (Extensions)",
    rate: "$175/Month",
    details:
      "For the muse who moves through life with volume, length, and intention. Includes 2 blow-dry services each month, crafted to keep your look flawless and your hair feeling fresh. Enjoy complimentary bubbles, a relaxing scalp massage, and 10% off our premium retail collection, all designed to make your maintenance routine feel like a moment.",
  },
];
